module.exports = __webpack_public_path__ + "avatar4.svg?5e3addf946bc3f874c64ab2643d355b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Avatar-Blue-Pool/avatar4.svg
// module id = 140
// module chunks = 2